/* global axios */
import ApiClient from './ApiClient';

class LiveConversationsAPI extends ApiClient {
  constructor() {
    super('live_conversations', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new LiveConversationsAPI();
